/* THIS IS TO ENTER NUMBERS ONLY IN THE INPUT FIELD */

import { Directive, HostListener, inject, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumericOnly]',
  standalone: false
})
export class NumericOnlyDirective {
  @Input() maxLength: number = 10; // Is default and will be overriden if present in html

  private control = inject(NgControl);

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;

    // Allow only 0-9
    let value = input.value.replace(/[^0-9]/g, '');

    if (this.maxLength) {
      value = value.substring(0, this.maxLength);
    }

    this.control.control?.setValue(value, { emitEvent: false });
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();

    const pastedText = event.clipboardData?.getData('text') || '';

    let value = pastedText.replace(/[^0-9]/g, '');

    if (this.maxLength) {
      value = value.substring(0, this.maxLength);
    }

    this.control.control?.setValue(value);
  }
}
